module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-container', [_c('v-row', {
    staticClass: "mt-5 pt-5 mb-5"
  }, [_c('v-col', {
    attrs: {
      "md3": "md3"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "md6": "md6",
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "display-2"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('blockquote', {
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa189798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submitted.vue
// module id = 127
// module chunks = 1